import { render, staticRenderFns } from "./backoffice-contratos-details.vue?vue&type=template&id=10e2f39c&scoped=true"
import script from "./backoffice-contratos-details.vue?vue&type=script&lang=ts"
export * from "./backoffice-contratos-details.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-contratos-details.vue?vue&type=style&index=0&id=10e2f39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2f39c",
  null
  
)

export default component.exports